// removed by extract-text-webpack-plugin
module.exports = {"main":"with-subtitle-main--2bliL","reversed":"with-subtitle-reversed--3OBh5","title":"with-subtitle-title--32avl","titleReversed":"with-subtitle-titleReversed--1AoTo","content":"with-subtitle-content--3I1OS","contentReversed":"with-subtitle-contentReversed--Amoxa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WithSubtitle/with-subtitle.scss
// module id = S5/n
// module chunks = 4